const getSwappedImageDomainUrl = (originalSrc, domainSwapConfig) => {
  if (!domainSwapConfig || !originalSrc) {
    return originalSrc;
  }
  const { fromDomain, toDomain } = domainSwapConfig;
  try {
    const url = new URL(originalSrc);
    if (url.hostname === fromDomain) {
      url.hostname = toDomain;
      return url.toString();
    }
  } catch {
    console.error("Invalid URL:", originalSrc);
  }
  return originalSrc;
};
export {
  getSwappedImageDomainUrl
};
